import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b808f49e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b808f49e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b808f49e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/erp-flexible-web21_zo1Z/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b808f49e')) {
      api.createRecord('b808f49e', component.options)
    } else {
      api.reload('b808f49e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b808f49e&scoped=true&", function () {
      api.rerender('b808f49e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/list/index.vue"
export default component.exports